import { render, staticRenderFns } from "./BlockConfirmation.vue?vue&type=template&id=27cafe60&scoped=true&"
import script from "./BlockConfirmation.vue?vue&type=script&lang=js&"
export * from "./BlockConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27cafe60",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/coachingclub/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27cafe60')) {
      api.createRecord('27cafe60', component.options)
    } else {
      api.reload('27cafe60', component.options)
    }
    module.hot.accept("./BlockConfirmation.vue?vue&type=template&id=27cafe60&scoped=true&", function () {
      api.rerender('27cafe60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/Includes/BlockConfirmation.vue"
export default component.exports